import { Controller } from '@hotwired/stimulus'

// Add-note modal for the work list. Lazily initializes TinyMCE once the
// dialog is visible (TinyMCE needs a laid-out container to size correctly),
// syncs editor content into the textarea before the remote form submits and
// clears the editor + closes the dialog after a successful save.
export default class extends Controller {
  static targets = ['form', 'errors']

  prepare() {
    setTimeout(() => {
      if (window.tinymce && !window.tinymce.get('work_list_note_content')) {
        window.tinymce.init({
          selector: '#work_list_note_content',
          height: 300,
          menubar: false,
          license_key: 'gpl',
          plugins: ['lists'],
          toolbar: 'bold italic underline | forecolor backcolor | fontsize | bullist numlist',
          content_style: "body { font-family: Inter, 'Segoe UI', system-ui, sans-serif; font-size: 14px; color: #101f3c; }"
        })
      }
    }, 50)
  }

  async submit(event) {
    event.preventDefault()
    if (window.tinymce) window.tinymce.triggerSave()

    const token = this.csrfToken()
    const response = await fetch(this.formTarget.action, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-CSRF-Token': token },
      body: new FormData(this.formTarget)
    })
    const json = await response.json()

    if (json.success) {
      this.errorsTarget.classList.add('hide')
      this.errorsTarget.innerHTML = ''

      const template = document.createElement('template')
      template.innerHTML = json.notes_html
      document.querySelectorAll('ul#work-list-notes, .no-work-list-notes').forEach((el) => {
        el.replaceWith(template.content.firstElementChild.cloneNode(true))
      })

      const editor = window.tinymce && window.tinymce.get('work_list_note_content')
      if (editor) editor.setContent('')
      this.modalController.close()
    } else {
      this.errorsTarget.innerHTML = json.errors_html
      this.errorsTarget.classList.remove('hide')
    }
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
  }

  get modalController() {
    return this.application.getControllerForElementAndIdentifier(this.element, 'modal')
  }
}
